import React, { useState, useEffect, useRef } from 'react';
import '../style/AdminMenu.scss';
import Button from "../components/ui/Button";

const AdminMenu = ({ isAdmin, handleProtectedNavigate, navigate, batch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // This effect handles closing the menu when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    // Cleanup on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="admin-menu-container" ref={menuRef}>
      <button
        type="button"
        className="settings-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Admin Settings"
        aria-expanded={isOpen}
      >
        <img
          src="settings.svg"
          alt="Settings Icon"
          className="settings-icon"
        />
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          <Button
            className="btn btn--hyperlink"
            onClick={() => handleProtectedNavigate(() => navigate(`/dashboard?batchId=${batch.batchId}`))}
            textButton="Tableau de bord"
          ></Button>
          {/* <button
            className="blueButton"
            onClick={() => handleProtectedNavigate(() => navigate(`/dashboard?batchId=${batch.batchId}`))}
          >
            Dashboard
          </button> */}
          <Button
            className="btn btn--hyperlink"
            onClick={() => handleProtectedNavigate(() => navigate(`/glossary-management?batchId=${batch.batchId}`))}
            textButton="Gestion du Glossaire"
          ></Button>
          {/* <button
            className="blueButton"
            onClick={() => handleProtectedNavigate(() => navigate(`/glossary-management?batchId=${batch.batchId}`))}
          >
            Gestion du Glossaire
          </button> */}
        </div>
      )}
    </div>
  );
};

export default AdminMenu;